import type { IntlShape } from 'react-intl'

export function formatTourV2SnapshotRoom(room: App.Tours.V2OfferSnapshotRoom, intl: IntlShape) {
  const {
    adultCount,
    childCount,
  } = room

  const parts: Array<string> = []
  if (adultCount) {
    parts.push(intl.formatMessage(
      {
        id: 'jMSvYdSjIW',
        defaultMessage: '{adultCount, plural, one {# adult} other {# adults}}',
        description: 'Adult occupancy text for tour v2 room snapshot',
      },
      { adultCount },
    ))
  }
  if (childCount) {
    parts.push(intl.formatMessage(
      {
        id: 'nMlMFipttf',
        defaultMessage: '{childCount, plural, one {# child} other {# children}}',
        description: 'Child occupancy text for tour v2 room snapshot',
      },
      { childCount },
    ))
  }

  return parts.join(', ')
}
